import React from 'react';

function Header() {
  return (
    <div className='header'><h1>Markdown Editor</h1></div>
  )
}

export default Header;